import { createSlice } from "@reduxjs/toolkit";

// True when the stored { organization, related } is already the same selection (by org id),
// so we can skip the write and avoid handing subscribers a new map reference on every re-select.
// Compares by ORGANIZATIONID because inside an Immer reducer the existing nested objects are
// draft proxies and never === the raw payload objects.
const isSameSelectedEntry = (existing, next) => {
    if (!existing || !next) {
        return false;
    }
    if (
        existing.organization?.ORGANIZATIONID !==
        next.organization?.ORGANIZATIONID
    ) {
        return false;
    }
    const a = existing.related || [];
    const b = next.related || [];
    return (
        a.length === b.length &&
        a.every(
            (org, index) => org?.ORGANIZATIONID === b[index]?.ORGANIZATIONID
        )
    );
};

const viewReportSlice = createSlice({
    name: "reportOrganization",
    initialState: {
        selectedOrganizationsReports: {},
        selectedOrganizationsIdReports: null,
        selectedRelatedOrganizationsForReports: [],
        portalUserData: [],
        getReportDetailsFromSlice: [],
        selectedReportViewId: null,
        selectedDataViewType: "",
    },
    reducers: {
        addSelectedOrganizationForReports(state, action) {
            const next = {
                organization: action.payload.organization,
                related: action.payload.related,
            };
            if (
                !isSameSelectedEntry(
                    state.selectedOrganizationsReports[action.payload.id],
                    next
                )
            ) {
                state.selectedOrganizationsReports[action.payload.id] = next;
            }
        },

        setSelectedOrgainzationsIdForReports(state, action) {
            state.selectedOrganizationsIdReports = action.payload;
        },

        setSelectedRelatedOrganizationsForReports(state, action) {
            state.selectedRelatedOrganizationsForReports = action.payload;
        },

        clearSelectedOrganizationsForReports(state) {
            state.selectedOrganizationsReports = {};
            state.selectedOrganizationsIdReports = {};
            state.selectedRelatedOrganizationsForReports = {};
        },

        setPortalUserData(state, action) {
            state.portalUserData = action.payload;
        },
        clearPortalUserData(state) {
            state.portalUserData = [];
        },
        setReportDetails(state, action) {
            state.getReportDetailsFromSlice = action.payload;
        },
        setSelectedReportViewId(state, action) {
            state.selectedReportViewId = action.payload;
        },
        setSelectedDataViewType(state, action) {
            state.selectedDataViewType = action.payload;
        },
    },
});

export const {
    addSelectedOrganizationForReports,
    setSelectedOrgainzationsIdForReports,
    clearSelectedOrganizationsForReports,
    setSelectedRelatedOrganizationsForReports,
    setPortalUserData,
    clearPortalUserData,
    setReportDetails,
    setSelectedReportViewId,
    setSelectedDataViewType,
} = viewReportSlice.actions;

export default viewReportSlice.reducer;
